export enum HistoryFor {
    Client = 1,
    Staff = 2,
    ClientLocation = 3,
    ClientContact = 4,
    CompanyPolicyHistory = 5
}
